import { ServiceErrorResponse } from './types';
import { DATA_API_URL, IS_DEV } from './config';

export type APIResponse<T> = T | ServiceErrorResponse;

const serverUrlRegex = /^\/([a-zA-Z0-9]*)\/([a-zA-Z0-9-]*).?/i;

export const extractServiceDetails = (url: string): {
  appId?: string;
  serviceName?: string;
} => {
  const results = serverUrlRegex.exec(url);
  if (results) {
    const appId = results[1];
    const serviceName = results[2];
    return {
      appId,
      serviceName,
    };
  }
  return {};
};

export const getServerUrl = (): string => {
  if (IS_DEV) {
    return DATA_API_URL;
  }

  const { appId, serviceName } = extractServiceDetails(window.location.pathname);
  return `${DATA_API_URL}/${appId}/${serviceName}`;
};
